import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-bulk-upload-estamp-step',
  templateUrl: './bulk-upload-estamp-step.component.html',
  styleUrls: ['./bulk-upload-estamp-step.component.scss'],
  standalone: false
})
export class BulkUploadEstampStepComponent implements OnInit {
  @Input() currentStep: number = 1; // Accept step value from parent

  userRole: string;
  uploadFileData: any;

  // Step definitions
  steps = [
    { number: 1, label: 'Upload Excel', route: 'excel-upload' },
    { number: 2, label: 'Upload PDFs', route: 'pdf-upload' }
  ];

  constructor(
    private router: Router,
    private storageService: StorageService
  ) {
    this.userRole = this.storageService.getRole() || null;
  }

  ngOnInit(): void {
    // Determine current step based on route
    const currentRoute = this.router.url;
    if (currentRoute.includes('excel-upload')) {
      this.currentStep = 1;
    } else if (currentRoute.includes('pdf-upload')) {
      this.currentStep = 2;
    }
  }

  back() {
    this.userRole === 'CLIENT'
      ? this.router.navigate(['doqfy/dashboard'])
      : this.router.navigate(['doqfy/admin-dashboard']);
  }
  goBackToExcel() {
    this.router.navigate(['/doqfy/bulk-upload-estamp/excel-upload']);
  }

  changeState(data: any) {
    this.uploadFileData = data;
  }

  getStepClass(step: number): string {
    if (this.currentStep === step) {
      return 'box-item_active';
    } else if (step < this.currentStep) {
      return 'boxOutline';
    } else {
      return 'box-item';
    }
  }

  getStepLabel(step: number): string {
    const stepData = this.steps.find((s) => s.number === step);
    return stepData ? stepData.label : `Step ${step}`;
  }

  canNavigateToStep(step: number): boolean {
    // User can only navigate to completed steps or current step
    return step <= this.currentStep;
  }

  navigateToStep(step: number) {
    if (!this.canNavigateToStep(step)) {
      return;
    }

    const stepData = this.steps.find((s) => s.number === step);
    if (stepData) {
      this.router.navigate([`/doqfy/bulk-upload-estamp/${stepData.route}`]);
    }
  }
}
